<template>
	<section>
		<b-overlay :show="loading" rounded="sm" no-wrap></b-overlay>
		<div class="card l-bg-blue-dark">
			<div class="card-statistic-3 p-3">
				<div class="card-icon card-icon-large"><i class="material-icons">&#xebf0;</i></div>
				<div class="mb-4">
					<h5 class="card-title mb-0">{{$t("dashboard.volumenAssigned")}}</h5>
				</div>
				<div class="row align-items-center mb-2 d-flex">
					<div class="col-8">
						<h2 class="d-flex align-items-center mb-0">
							{{assigned.total}}
						</h2>
					</div>
					<div class="col-4 text-right">
						<b>{{assigned.percent}}% </b>
					</div>
				</div>
			</div>
		</div>
		<div class="card l-bg-blue-dark">
			<div class="card-statistic-3 p-3">
				<div class="card-icon card-icon-large"><i class="material-icons">&#xef76;</i></div>
				<div class="mb-4">
					<h5 class="card-title mb-0">{{$t("dashboard.volumenAccepted")}}</h5>
				</div>
				<div class="row align-items-center mb-2 d-flex">
					<div class="col-8">
						<h2 class="d-flex align-items-center mb-0">
							{{accepted.total}}<small>/{{assigned.total}}</small>
						</h2>
					</div>
					<div class="col-4 text-right">
						<b>{{accepted.percent}}%</b>
					</div>
				</div>
				<b-progress :value="accepted.percent" max="100" class="mb-3" variant="info" style="height: 8px;" striped :animated="true"></b-progress>
			</div>
		</div>
		<div class="card l-bg-blue-dark">
			<div class="card-statistic-3 p-3">
				<div class="card-icon card-icon-large"><i class="material-icons">&#xe99a;</i></div>
				<div class="mb-4">
					<h5 class="card-title mb-0">{{$t("dashboard.volumenRejected")}}</h5>
				</div>
				<div class="row align-items-center mb-2 d-flex">
					<div class="col-8">
						<h2 class="d-flex align-items-center mb-0">
							{{rejected.total}}<small>/{{assigned.total}}</small>
						</h2>
					</div>
					<div class="col-4 text-right">
						<b>{{rejected.percent}}% </b>
					</div>
				</div>
				<b-progress :value="rejected.percent" max="100" class="mb-3" variant="info" style="height: 8px;"  striped :animated="true"></b-progress>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	props: {
		filters: {
			type : Object,
			required: true
		},
		triggerSearch:{
			type : Number,
			required: true
		}
	},
	data() {
		return {
			loading:false,
			assigned:{total:0,percent:0},
			accepted:{total:0,percent:0},
			rejected:{total:0,percent:0}
		}
	},
	methods: {
		fetchData(){
			this.loading = true;
			this.$root.api.get(`/dashboard/resume`,{params: {filters:this.filters}})
			.then((res) => {
				this.assigned = res.data.assigned;
				this.accepted = res.data.accepted;
				this.rejected = res.data.rejected;
			})
			.catch(this.$root.handleRequestError)
			.finally(()=>this.loading=false)
		}
	},
	mounted(){
		this.fetchData();//realiza la busqueda
	},
	watch:{
		triggerSearch(){//este valor es reactivo, el padre decide en que momento se dispara la busqueda
			this.fetchData();
		}
	},
};
</script>

<style scoped>
.card {
    background-color: #fff;
    border-radius: 10px;
    border: none;
    position: relative;
    margin-bottom: 20px;
    box-shadow: 0 0.46875rem 2.1875rem rgba(90,97,105,0.1), 0 0.9375rem 1.40625rem rgba(90,97,105,0.1), 0 0.25rem 0.53125rem rgba(90,97,105,0.12), 0 0.125rem 0.1875rem rgba(90,97,105,0.1);
}
.l-bg-blue-dark {
    background: linear-gradient(to right, #373b44, #4286f4) !important;
    color: #fff;
}
.card .card-statistic-3 .card-icon-large .material-icons, .card .card-statistic-3 .card-icon-large .far, .card .card-statistic-3 .card-icon-large .fab, .card .card-statistic-3 .card-icon-large .fal {
    font-size: 110px !important;
}
.card .card-statistic-3 .card-icon {
    text-align: center;
    line-height: 50px;
    margin-left: 15px;
    color: #000;
    position: absolute;
    right: 0px;
    top: .4rem!important;
    opacity: 0.1;
}
</style>
